import { CommitteeMemberItem } from "./CommitteeMemberItem";

export default CommitteeMemberItem;
